import React, { Component } from "react";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Paper,
  Typography,
  withStyles,
  Snackbar,
} from "@material-ui/core";
import withServices from "../../hocs/withServices";
import { Alert } from "@material-ui/lab";

const styles = (theme) => ({
  pageContent: {
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
    },
  },
});

class CreateUsers extends Component {
  state = {
    successMessage: "",
    errorMessage: "",
    openSuccess: false,
    openError: false,

    name: "",
    surname: "",
    patronymic: "",
    email: "",
    password: "",
    confirmPassword: "",
    roleId: "",

    roles: [],
  };

  componentDidMount() {
    const {
      createUsers: { getRoles },
    } = this.props.services;

    getRoles().then((response) => {
      this.setState({ roles: response.data });
    });
  }

  onSubmit = () => {
    const {
      name,
      surname,
      patronymic,
      email,
      password,
      confirmPassword,
      roleId,
    } = this.state;
    const {
      createUsers: { createUser },
    } = this.props.services;

    if (password !== confirmPassword) {
      this.setState({ errorMessage: "Пароли не совпадают" }, () =>
        this.setState({ openError: true })
      );

      return;
    }

    createUser({
      name: name || null,
      surname: surname || null,
      patronymic: patronymic || null,
      email: email || null,
      password: password || null,
      roleId: roleId || null,
    })
      .then(() => {
        this.setState(
          { successMessage: "Новый пользователь был успешно создан" },
          () => this.setState({ openSuccess: true })
        );
      })
      .catch((error) => {
        console.error(error);
        this.setState(
          { errorMessage: "В форме присутствуют некорректно заполненные поля" },
          () => this.setState({ openError: true })
        );
      });
  };

  render() {
    const { classes } = this.props;
    const {
      roleId,
      roles,
      openSuccess,
      openError,
      successMessage,
      errorMessage,
    } = this.state;

    return (
      <>
        <Snackbar
          open={openSuccess}
          autoHideDuration={1500}
          onClose={() => this.setState({ openSuccess: false })}
        >
          <Alert
            severity="success"
            onClose={() => this.setState({ openSuccess: false })}
          >
            {successMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openError}
          autoHideDuration={1500}
          onClose={() => this.setState({ openError: false })}
        >
          <Alert
            severity="error"
            onClose={() => this.setState({ openError: false })}
          >
            {errorMessage}
          </Alert>
        </Snackbar>

        <Paper className={classes.pageContent}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6" id="tableTitle" component="div">
                Создание новых пользователей
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="name"
                label="Имя"
                onChange={(event) =>
                  this.setState({ name: event.target.value })
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Фамилия"
                onChange={(event) =>
                  this.setState({ surname: event.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                label="Отчество"
                onChange={(event) =>
                  this.setState({ patronymic: event.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Почта"
                onChange={(event) =>
                  this.setState({ email: event.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Пароль"
                type="password"
                onChange={(event) =>
                  this.setState({ password: event.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Подтверждение пароля"
                type="password"
                onChange={(event) =>
                  this.setState({ confirmPassword: event.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                select
                required
                fullWidth
                label="Роль для нового пользователя"
                onChange={(event) =>
                  this.setState({ roleId: event.target.value })
                }
                value={roleId}
              >
                <MenuItem value="none" disabled>
                  Выберите один из вариантов
                </MenuItem>
                {roles.map(({ id, roleName }) => (
                  <MenuItem key={id} value={id}>
                    {roleName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={this.onSubmit}
                  disabled={!roleId}
                >
                  Создать нового пользователя
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }
}

export default withStyles(styles)(withServices()(CreateUsers));
